export default "__VITE_ASSET__DqARfm9r__"